import React from "react";
import { Input } from "@/components/ui/input";

interface NameStepProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onKeyDown: (e: React.KeyboardEvent) => void;
}

const NameStep: React.FC<NameStepProps> = ({ value, onChange, onKeyDown }) => {
  return (
    <div>
      <Input
        name="name"
        type="text"
        value={value}
        onChange={onChange}
        onKeyDown={onKeyDown}
        placeholder="e.g. Oceanview Villa"
        className="w-full text-sm font-light leading-relaxed focus-visible:outline-none focus-visible:ring-0 rounded-lg"
      />
    </div>
  );
};

export default NameStep;
